<template>
  <div v-show="modalEditar">
    <q-modal
      v-model="modalEditar"
      :content-css="{minWidth: '100vw', minHeight: '100vh'}"
    >
      <q-card>
        <div class="pad-10">
          <q-icon
            name="fas fa-search"
            style="float: left;"
          /><span> <b>&nbsp;&nbsp;Visualizar processo</b></span>
          <q-btn
            flat
            rounded
            dense
            round
            size="sm"
            :icon="'fas fa-times'"
            style="margin-top: -2px; float: right;"
            @click="modalEditar=false"
          />
        </div>
        <q-card-separator style="font-weight: bold; border-bottom: 1px solid rgb(9, 51, 112);" />
        <div class="gvn-cabecalho mrg-b-10">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Nº do Processo / Ano: </strong>
              {{this.numProcesso}}/{{this.anoProcesso}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Status atual: </strong>
              {{this.statusAtual}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong>Situação: </strong>
              {{this.situacao}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Nº Protocolo: </strong>
              {{this.numProtocolo}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Rota / Sequência: </strong>
              {{this.numRota}}/{{this.numSequencia}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Tipo de Processo: </strong>
              {{this.desTipoProcesso}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Assunto: </strong>
              {{this.desAssunto}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Requerente: </strong>
              {{this.nomRequerente}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Subassunto: </strong>
              {{this.desSubassunto}}
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Local de origem </strong>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Localização atual </strong>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <strong>Órgão: </strong>
              {{this.desOrgao}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <strong>Órgão: </strong>
              {{this.desOrgaoAtual}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Unidade: </strong>
              {{this.desUnidade}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Unidade: </strong>
              {{this.desUnidadeAtual}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Setor: </strong>
              {{this.desSetor}}
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <strong>Setor: </strong>
              {{this.desSetorAtual}}
            </div>
            <div class="col-sm-1 text-right">
              <q-tooltip>Histórico de Movimentação</q-tooltip>
              <q-btn
                id="visualizarHistorico"
                name="visualizarHistorico"
                icon="fas fa-history"
                color="primary"
                @click="visualizarHistorico"
                flat
              >&ensp;&ensp;Histórico
              </q-btn>
            </div>
            <div class="col-sm-1 text-right">
              <q-tooltip>Comprovante de encaminhamento</q-tooltip>
              <q-btn
                id="imprimirComprovanteEncaminhamento"
                name="imprimirComprovanteEncaminhamento"
                icon="fa fa-print"
                color="primary"
                @click="imprimirComprovanteEncaminhamento"
                flat
              >&ensp;&ensp;Imprimir
              </q-btn>
            </div>
          </div>
        </div>
        <q-card-separator />
        <q-tabs
          class="mrg-t-10 mrg-l-10"
          inverted
          v-model="abaSelecionada"
        >
          <q-tab
            slot="title"
            label="Observações"
            name="observacoes"
          />
          <q-tab
            slot="title"
            label="Pendências"
            name="pendencias"
          />
          <q-tab
            slot="title"
            label="Documentos"
            name="documentos"
          />
          <q-tab-pane
            name="observacoes"
            :keep-alive="true"
          >
            <observacoes
              ref="refObservacoes"
              :paginaStatus="paginaStatus"
            />
          </q-tab-pane>
          <q-tab-pane
            name="pendencias"
            :keep-alive="true"
          >
            <pendencias
              ref="refPendencias"
              :paginaStatus="paginaStatus"
            />
          </q-tab-pane>
          <q-tab-pane
            name="documentos"
            :keep-alive="true"
          >
            <documentos
              ref="refDocumentos"
              :paginaStatus="paginaStatus"
            />
          </q-tab-pane>
        </q-tabs>
      </q-card>
      <div class="col-sm-6 text-right">
        <q-btn
          style="margin-right: 10px; background-color: #616161;"
          id="Fechar"
          name="Fechar"
          @click="modalEditar = false"
          label="Fechar"
        >
        </q-btn>
      </div>
    </q-modal>
  </div>
</template>
<script>
import api from 'components/util/api'
import util from 'components/util/util'
import Documentos from 'components/telaMonitora/documentos/index'
import Observacoes from 'components/telaMonitora/observacoes/index'
import Pendencias from 'components/telaMonitora/pendencias/index'
import utilHttp from 'components/util/utilHttp'
export default {
  data () {
    return {
      chaveLocalStorage: 'telaMonitora',
      abaSelecionada: 'observacoes',
      apiImprimirRelatorio: api.RELATORIO_COMPROVANTE_ENCAMINHAMENTO,
      modalEditar: false,
      parametrosSistema: '',
      statusAtual: '',
      situacao: '',
      numProcesso: '',
      anoProcesso: '',
      numProtocolo: '',
      numRota: '',
      numSequencia: '',
      desTipoProcesso: '',
      desAssunto: '',
      nomRequerente: '',
      desSubassunto: '',
      desOrgao: '',
      desUnidade: '',
      desSetor: '',
      desOrgaoAtual: '',
      desUnidadeAtual: '',
      desSetorAtual: '',
      aberturaProcesso: '',
      paginaStatus: {
        caminhoMigalha: [],
        arrayPendencias: [],
        arrayObservacaoProcesso: [],
        arrayMovimentacaoProcesso: [],
        arrayDocumentosNecessarios: [],
        arrayDadosAnexadosProcesso: [],
        arrayDadosAnexadosSolicitacao: [],
        operacao: {},
        observacoes: {},
        pendencias: {},
        documentos: {},
        aberturaProcesso: {
          requerente: {},
          formaSolicitacao: {},
          justificativa: {},
          tipoProcesso: {},
          subassunto: { assunto: {} },
          roteiro: {}
        },
        movimentacaoProcesso: {
          setor: {
            unidade: {
              orgao: {}
            }
          },
          aberturaProcesso: {
            requerente: {},
            justificativa: {},
            tipoProcesso: {},
            roteiro: {},
            subassunto: {
              assunto: {}
            }
          }
        }
      },
      relacaoAbas: [
        {
          ref: 'refObservacoes',
          nome: 'observacoes'
        },
        {
          ref: 'refPendencias',
          nome: 'pendencias'
        },
        {
          ref: 'refDocumentos',
          nome: 'documentos'
        }
      ]
    }
  },
  methods: {
    carregarComponente (item, arrayObservacaoProcesso, arrayMovimentacaoProcesso, arrayPendencias, arrayDocumentosNecessarios, arrayDadosAnexadosProcesso, arrayDadosAnexadosSolicitacao) {
      this.$nextTick(() => {
        this.modalEditar = true
        this.paginaStatus.arrayPendencias = arrayPendencias
        this.paginaStatus.arrayObservacaoProcesso = arrayObservacaoProcesso
        this.paginaStatus.arrayMovimentacaoProcesso = arrayMovimentacaoProcesso
        this.paginaStatus.arrayDocumentosNecessarios = arrayDocumentosNecessarios
        this.paginaStatus.arrayDadosAnexadosProcesso = arrayDadosAnexadosProcesso
        this.paginaStatus.arrayDadosAnexadosSolicitacao = arrayDadosAnexadosSolicitacao
        item = util.clonarObjeto(item)
        this.aberturaProcesso = item.aberturaProcesso
        this.statusAtual = item.aberturaProcesso.indStatusProcesso
        this.situacao = item.aberturaProcesso.desSituacao
        this.numProcesso = item.movimentacaoProcesso.aberturaProcesso.numProcesso
        this.anoProcesso = item.movimentacaoProcesso.aberturaProcesso.anoProcesso
        this.numProtocolo = item.movimentacaoProcesso.aberturaProcesso.numProtocolo
        this.numRota = item.movimentacaoProcesso.aberturaProcesso.roteiro.numRota
        this.numSequencia = item.movimentacaoProcesso.numSequencia
        this.desTipoProcesso = item.movimentacaoProcesso.aberturaProcesso.tipoProcesso.desTipoProcesso
        this.desAssunto = item.movimentacaoProcesso.aberturaProcesso.subassunto.assunto.desAssunto
        this.nomRequerente = item.movimentacaoProcesso.aberturaProcesso.requerente.nomRequerente
        this.desSubassunto = item.movimentacaoProcesso.aberturaProcesso.subassunto.desSubassunto
        this.desOrgao = item.movimentacaoProcesso.setor.unidade.orgao.desOrgao
        this.desUnidade = item.movimentacaoProcesso.setor.unidade.desUnidade
        this.desSetor = item.movimentacaoProcesso.setor.desSetor
        this.desOrgaoAtual = item.movimentacaoProcesso.setorConfirmacao.unidade.orgao.desOrgao
        this.desUnidadeAtual = item.movimentacaoProcesso.setorConfirmacao.unidade.desUnidade
        this.desSetorAtual = item.movimentacaoProcesso.setorConfirmacao.desSetor
        this.inicializarAbas()
      })
    },
    visualizarHistorico () {
      var self = this
      self.paginaStatus.aberturaProcesso = self.aberturaProcesso
      if (!self.paginaStatus.aberturaProcesso.representante) {
        self.paginaStatus.aberturaProcesso.representante = ''
      }
      self.paginaStatus.desabilitarEdicao = true
      self.paginaStatus.operacao = {
        descricao: 'Histórico',
        icone: 'fas fa-history'
      }
      self.$router.push({
        name: 'aberturaProcessoVisualizar',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    imprimirComprovanteEncaminhamento () {
      var self = this
      let url = ''
      url = self.apiImprimirRelatorio.concat('?codProcesso=').concat(self.aberturaProcesso.codProcesso.toString())
      url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
      window.open(url)
    },
    buscarParametrosSistema () {
      var self = this
      utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
        if (resposta.body !== undefined && resposta.body !== '') {
          self.parametrosSistema = resposta.body
        }
      })
    },
    async inicializarAbas () {
      var self = this
      carregarComponenteAba()
        .then(() => setarAbaDocumentos())
        .then(() => setarAbaPendencias())
        .then(() => setarAbaObservacoes())

      function setarAbaPendencias () {
        self.abaSelecionada = 'pendencias'
        return Promise.resolve(true)
      }
      function setarAbaDocumentos () {
        self.abaSelecionada = 'documentos'
        return Promise.resolve(true)
      }
      function setarAbaObservacoes () {
        self.abaSelecionada = 'observacoes'
        return Promise.resolve(true)
      }
      function carregarComponenteAba () {
        if (util.validarObjeto(self.$refs.refObservacoes)) {
          self.$refs.refObservacoes.carregarComponente(self.paginaStatus.arrayObservacaoProcesso, self.paginaStatus.arrayMovimentacaoProcesso)
        }
        if (util.validarObjeto(self.$refs.refDocumentos)) {
          self.$refs.refDocumentos.carregarComponente(self.paginaStatus.arrayDocumentosNecessarios, self.paginaStatus.arrayDadosAnexadosProcesso, self.paginaStatus.arrayDadosAnexadosSolicitacao)
        }
        if (util.validarObjeto(self.$refs.refPendencias)) {
          self.$refs.refPendencias.carregarComponente(self.paginaStatus.arrayPendencias)
        }
        return Promise.resolve(true)
      }
    }
  },
  watch: {
    datBaixa: {
      handler (valor) {
        this.paginaStatus.frota.datBaixa = valor
      }
    },
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    abaSelecionada (valor) {
      var self = this
      if (util.validarObjeto(self.$refs.refObservacoes)) this.paginaStatus.observacoes = { ...self.$refs.refObservacoes.getObjeto(), ...this.paginaStatus.observacoes }
      if (util.validarObjeto(self.$refs.refPendencias)) this.paginaStatus.pendencias = { ...self.$refs.refPendencias.getObjeto(), ...this.paginaStatus.pendencias }
      if (util.validarObjeto(self.$refs.refDocumentos)) this.paginaStatus.documentos = { ...self.$refs.refDocumentos.getObjeto(), ...this.paginaStatus.documentos }
    }
  },
  mounted () {
    if (this.$route.params.paginaStatus) {
      this.paginaStatus = this.$route.params.paginaStatus
    } else if (util.recuperarDoStorage(this.chaveLocalStorage)) {
      this.paginaStatus = util.recuperarDoStorage(this.chaveLocalStorage)
    }
    this.paginaStatus.caminhoMigalha = [
      {
        icone: 'fa fa-home',
        descricao: 'Home',
        rotaNome: 'index'
      }
    ]
    this.buscarParametrosSistema()
  },
  components: { Documentos, Observacoes, Pendencias }
}
</script>
